
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import {
  Swiper,
  SwiperSlide
} from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default BaseCmsBlock.extend({
  name: "AboutPageTeamBlock",

  components: {
    Swiper,
    SwiperSlide,
    EmploeCard: () => import("./components/AboutPageTeamBlock/EmploeCard.vue")
  },

  data: function() {
    return {
      swiperOptions: {
        spaceBetween: 16,
        slidesPerView: 1,
        slidesPerGroup: 1,
        pagination: {
          el: ".about-page-team__staff_mobile-swiper__slider-pagination-dots-list",
          type: 'bullets',
          dynamicBullets: true
        },
      },
      topScroll: null,
      scrollDirection: 'bottom', // направление скрола по кнопке
    }
  },

  computed: {
    isStickyScrollButton: function () {
      if (!process.client || !window) {
        return false
      }
      const parentBlock = document.querySelector('.about-page-team__content')?.getBoundingClientRect() || 0;
      const examenationPosition = Boolean(window.innerHeight / 3 < parentBlock.height + parentBlock.top - 600)

      return this.topScroll?.top - 210 <= 0 && examenationPosition;
      // parentBlock.height >= window.innerHeight &&
    }
  },

  methods: {
    scrollOfTopPage: function () {
      const fullCardsBlock = document.querySelector('.about-page-team__staff')?.getBoundingClientRect();

      this.topScroll = fullCardsBlock
    },
    handleScrollButton: function () {
      if (this.scrollDirection === 'bottom') {
        this.autoScrollDown()
      } else {
        this.autoScrollTop()
      }
    },
    autoScrollDown: function() {
      const fullCardsBlock = document.querySelector('.about-page-team__staff');
      const oneCard = document.querySelector('.emploe-card');
      const oneCardHeight = oneCard.getBoundingClientRect().height;

      const topPosition = fullCardsBlock.offsetTop + oneCardHeight;

      if ( fullCardsBlock.scrollHeight - fullCardsBlock.getBoundingClientRect().height  > fullCardsBlock.scrollTop) {
        fullCardsBlock.scrollTop += topPosition;
      } else {
        this.scrollDirection = 'top'
        this.autoScrollTop()
      }
    },
    autoScrollTop: function () {
      const fullCardsBlock = document.querySelector('.about-page-team__staff');
      const oneCard = document.querySelector('.emploe-card');
      const oneCardHeight = oneCard.getBoundingClientRect().height;

      const topPosition = -(fullCardsBlock.offsetTop + oneCardHeight);

      if (fullCardsBlock.scrollTop > 0) {
        fullCardsBlock.scrollTop += topPosition;
      } else {
        this.scrollDirection = 'bottom'
        this.autoScrollDown()
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollOfTopPage);
  },
  unMounted() {
    window.removeEventListener('scroll', null);
  }
});
